export { HomePage } from './HomePage/HomePage';
export { LoginPage } from './LoginPage/LoginPage';
export { SignUpPage } from './SignUpPage/SignUpPage';
export { MoviePage } from './MoviePage/MoviePage';
export { ProfilePage } from './ProfilePage/ProfilePage';
